import { useCallback } from 'react';

import { StepProps, useFlowState } from '@betterment/js-runtime';

import SuccessOverlay from '../../Shared/components/SuccessOverlay';
import { locationAssign } from '../../Shared/path-helpers';
import { urlBuilder } from '../../Shared/urlBuilder';
import { PortfolioFlowState } from '../data';

const PortfolioSuccessStep: React.FC<React.PropsWithChildren<StepProps>> = () => {
  const {
    flowState: {
      values: { accountId, shouldReturnToAppSummary },
    },
  } = useFlowState<PortfolioFlowState>();

  const complete = useCallback(() => {
    if (shouldReturnToAppSummary) {
      locationAssign(urlBuilder.appHome.absolute());
    } else {
      locationAssign(urlBuilder.appAccount.absolute({ accountId }));
    }
  }, [accountId, shouldReturnToAppSummary]);

  return <SuccessOverlay message="Allocation settings updated successfully!" onCompletion={complete} />;
};

export default PortfolioSuccessStep;
